<template>
  <div class="heading-elements custom-toolbar">
    <ul class="list-inline mb-0">
      <li v-if="permissions.store">
        <a
            @click="$emit('store')"
            v-b-tooltip
            title="Cadastrar"
            class="action-btn"
        ><i class="fa fa-plus"></i></a>
      </li>
      <li v-if="permissions.store">
        <a
            @click="$emit('create', null, 1)"
            v-b-tooltip
            title="Escanear Código"
            class="action-btn"
        ><i class="fa fa-barcode"></i></a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ToolbarActions",
  props: {
    permissions: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.action-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    padding: 10px;
    border-radius: 12px !important; /* Arrendondamento solicitado */
    transition: all 0.3s ease;
    background: transparent;
    color: #4B5563;
    border: 1px solid #E5E7EB;
    margin-right: 4px;
}
.action-btn:hover {
    background: #F3F4F6;
    color: #1F2937;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}
.list-inline > li {
    display: inline-block;
    margin-right: 4px;
}
.heading-elements .list-inline {
  display: block;
}

@media (max-width: 767.98px) {
    .custom-toolbar {
        display: block !important;
        position: static !important;
        width: 100%;
        text-align: center;
        padding: 5px 0 15px 0;
        box-shadow: none !important;
        border: none !important;
        background: transparent !important;
    }
    .custom-toolbar .list-inline {
        display: flex;
        justify-content: center;
        gap: 8px;
    }
    .custom-toolbar .list-inline > li {
        margin-right: 0;
    }
}
</style>
